import { render } from "./all-course.vue?vue&type=template&id=05d671ea&scoped=true"
import script from "./all-course.vue?vue&type=script&lang=js"
export * from "./all-course.vue?vue&type=script&lang=js"

import "./all-course.vue?vue&type=style&index=0&id=05d671ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d671ea"]])

export default __exports__